var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_caution",
    d: "M735.492,424.754a12,12,0,1,1-12-12A12,12,0,0,1,735.492,424.754Zm-10.451.729v-7.074a1.522,1.522,0,1,0-3.043,0v7.074a1.522,1.522,0,1,0,3.043,0Zm-.19,6.314a1.939,1.939,0,0,0,.571-1.331,1.784,1.784,0,0,0-.571-1.331,1.934,1.934,0,0,0-1.331-.571,1.78,1.78,0,0,0-1.331.571,1.932,1.932,0,0,0-.571,1.331,1.782,1.782,0,0,0,.571,1.331,1.839,1.839,0,0,0,2.662,0Z",
    transform: "translate(-711.492 -412.754)",
    fill: "#4c125a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3f98db6211d83997c266a3da1cfac23f.svg";
export { ForwardRef as ReactComponent };